import { createSlice } from '@reduxjs/toolkit';

import type { MyOrganization, PersonOfContact } from './types';

export const slice = createSlice({
    initialState: {
        currentOrganization: undefined as MyOrganization | undefined,
        isNewOrganization: false as boolean,
        orgPersonOfContact: undefined as PersonOfContact | undefined
    },

    name: 'useCurrentOrganization',

    reducers: {
        currentOrganization: (state, action) => {
            state.currentOrganization = action.payload;
        },

        isNewOrganization: (state, action) => {
            state.isNewOrganization = action.payload;
        },

        orgPersonOfContact: (state, action) => {
            state.orgPersonOfContact = action.payload;
        }
    }
});

export default slice.reducer;
